// src/auth/screens/TenantPicker.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../AuthContext.jsx';
import { COLORS, RADII, SHADOW, FONT_SANS } from '../../constants/theme.js';

export default function TenantPicker() {
  const { tenants, selectTenant, isSuperadmin, setAdminMode } = useAuth();
  const { t } = useTranslation('auth');
  const navigate = useNavigate();

  function handleSuperadminEntry() {
    setAdminMode(true);
    navigate('/admin/users', { replace: true });
  }

  // Tenant rows read as secondary buttons (white on `campi`); the superadmin
  // entry is the one accent-tinted row so it stays visually separate.
  const rowStyle = {
    width: '100%',
    padding: '14px 18px',
    borderRadius: RADII.control,
    border: `1px solid ${COLORS.border}`,
    background: COLORS.field,
    color: COLORS.ink,
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '15px',
    fontWeight: 600,
    fontFamily: FONT_SANS,
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: COLORS.bg, fontFamily: FONT_SANS,
      padding: '24px', boxSizing: 'border-box',
    }}>
      <div style={{
        width: '100%', maxWidth: '420px',
        background: COLORS.surface,
        border: `1px solid ${COLORS.border}`,
        borderRadius: RADII.section,
        boxShadow: SHADOW.card,
        padding: '40px',
        boxSizing: 'border-box',
      }}>
        <h1 style={{ color: COLORS.ink, fontSize: '24px', fontWeight: 700, margin: '0 0 8px' }}>
          {t('tenantPicker.title')}
        </h1>
        <p style={{ color: COLORS.textTertiary, fontSize: '14px', margin: '0 0 28px' }}>
          {t('tenantPicker.subtitle')}
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {tenants.map(tenant => (
            <button
              key={tenant.tenant_id}
              onClick={() => selectTenant(tenant.tenant_id)}
              style={rowStyle}
            >
              {tenant.display_name}
              <span style={{ display: 'block', fontSize: '12px', color: COLORS.textTertiary, fontWeight: 400, marginTop: '2px' }}>
                {tenant.role}
              </span>
            </button>
          ))}
        </div>

        {isSuperadmin && (
          <>
            <hr style={{ border: 'none', borderTop: `1px solid ${COLORS.border}`, margin: '24px 0' }} />
            <button
              onClick={handleSuperadminEntry}
              style={{
                ...rowStyle,
                border: `1px solid ${COLORS.accent}`,
                background: COLORS.accentSoft,
                color: COLORS.accent,
              }}
            >
              {t('tenantPicker.superadminButton')}
              <span style={{ display: 'block', fontSize: '12px', color: COLORS.textTertiary, fontWeight: 400, marginTop: '2px' }}>
                {t('tenantPicker.superadminSubtitle')}
              </span>
            </button>
          </>
        )}
      </div>
    </div>
  );
}
